// extracted by mini-css-extract-plugin
module.exports = {"fullscreenMode":"FullScreenToggle_fullscreenMode__3WA2E","fullScreenIcon":"FullScreenToggle_fullScreenIcon__2Y3Jv"};